import React from 'react'
import Box from './box'
import merge from 'deepmerge'

interface IRow {
  direction?: 'column' | 'row' | Array<'column' | 'row'>
  reverse?: boolean | boolean[]
  wrap?: boolean | boolean[]
  content?:
    | 'start'
    | 'end'
    | 'center'
    | 'between'
    | 'around'
    | Array<'start' | 'end' | 'center' | 'between' | 'around'>
  items?:
    | 'start'
    | 'end'
    | 'center'
    | 'stretch'
    | 'baseline'
    | Array<'start' | 'end' | 'center' | 'stretch' | 'baseline'>
  contentExtraSpace?:
    | 'start'
    | 'end'
    | 'center'
    | 'between'
    | 'around'
    | Array<'start' | 'end' | 'center' | 'between' | 'around'>
  css?: any
  onClick?: any
}

class Row extends React.Component<IRow, any> {
  constructor(props) {
    super(props)
  }
  public render() {
    return (
      <Box
        css={merge.all([containerStyle(this.props), this.props.css || {}])}
        onClick={this.props.onClick ? this.props.onClick : null}
      >
        {this.props.children}
      </Box>
    )
  }
}

const containerStyle = props => {
  const style: any = {
    display: 'flex',
    width: '100%'
  }

  if (props.direction) {
    Array.isArray(props.direction)
      ? (style.flexDirection = props.direction.map(direction => direction))
      : (style.flexDirection = props.direction)
  }
  if (props.reverse) {
    Array.isArray(props.reverse)
      ? (style.flexDirection = props.reverse.map((reverse, index) => {
          if (reverse) {
            return `${props.direction[index]}-reverse`
          } else {
            return props.direction[index]
          }
        }))
      : (style.flexDirection = `${props.direction}-reverse`)
  }

  if (props.wrap) {
    Array.isArray(props.wrap)
      ? (style.flexWrap = props.wrap.map(isWrap =>
          isWrap ? 'wrap' : 'nowrap'
        ))
      : (style.flexWrap = props.wrap ? 'wrap' : 'nowrap')
  }

  if (props.content) {
    if (Array.isArray(props.content)) {
      style.justifyContent = props.content.map(content => {
        if (content === 'start') {
          return 'flex-start'
        } else if (content === 'end') {
          return 'flex-end'
        } else if (content === 'center') {
          return 'center'
        } else if (content === 'between') {
          return 'space-between'
        } else if (content === 'around') {
          return 'space-around'
        } else {
          return ''
        }
      })
    } else {
      switch (props.content) {
        case 'start':
          style.justifyContent = 'flex-start'
          break
        case 'end':
          style.justifyContent = 'flex-end'
          break
        case 'center':
          style.justifyContent = 'center'
          break
        case 'between':
          style.justifyContent = 'space-between'
          break
        case 'around':
          style.justifyContent = 'space-around'
          break
      }
    }
  }

  if (props.items) {
    if (Array.isArray(props.items)) {
      style.alignItems = props.items.map(item => {
        if (item === 'start') {
          return 'flex-start'
        } else if (item === 'end') {
          return 'flex-end'
        } else if (item === 'center') {
          return 'center'
        } else if (item === 'stretch') {
          return 'stretch'
        } else if (item === 'baseline') {
          return 'baseline'
        } else {
          return ''
        }
      })
    } else {
      switch (props.items) {
        case 'start':
          style.alignItems = 'flex-start'
          break
        case 'end':
          style.alignItems = 'flex-end'
          break
        case 'center':
          style.alignItems = 'center'
          break
        case 'stretch':
          style.alignItems = 'stretch'
          break
        case 'baseline':
          style.alignItems = 'baseline'
          break
      }
    }
  }

  if (props.contentExtraSpace) {
    if (Array.isArray(props.contentExtraSpace)) {
      style.alignContent = props.contentExtraSpace.map(extraSpace => {
        if (extraSpace === 'start') {
          return 'flex-start'
        } else if (extraSpace === 'end') {
          return 'flex-end'
        } else if (extraSpace === 'center') {
          return 'center'
        } else if (extraSpace === 'stretch') {
          return 'stretch'
        } else if (extraSpace === 'between') {
          return 'space-between'
        } else if (extraSpace === 'around') {
          return 'space-around'
        } else {
          return ''
        }
      })
    } else {
      switch (props.contentExtraSpace) {
        case 'start':
          style.alignContent = 'flex-start'
          break
        case 'end':
          style.alignContent = 'flex-end'
          break
        case 'center':
          style.alignContent = 'center'
          break
        case 'stretch':
          style.alignContent = 'stretch'
          break
        case 'between':
          style.alignContent = 'space-between'
          break
        case 'around':
          style.alignContent = 'space-around'
          break
      }
    }
  }

  return style
}

export default Row
